import Product from '@grafikr/shopify-typescript/type/object/Product';
import Variant from '@grafikr/shopify-typescript/type/object/Variant';
import { component } from 'picoapp';
import formatMoney from 'utils/format-money';
import OptionSelector from 'utils/option-selector';
import OverflowScroller from 'utils/overflow-scroller';

export default component(async (node) => {
  const asideElement:HTMLElement = node.querySelector('[data-aside]');
  OverflowScroller(asideElement);

  const data: Product = JSON.parse(node.querySelector('[data-data]').textContent);
  const { chosenQuantity: chosenQuantityTranslation } = window.theme.strings;
  const variantSelector:HTMLSelectElement = node.querySelector('select[id]');
  const quantity:HTMLSelectElement = node.querySelector('input[data-quantity]');

  const form = node.querySelector('form');

  form.addEventListener('submit', (e) => {
    e.preventDefault();
    const currentVariantID = parseInt(variantSelector.value, 10);
    const currentQuantity = parseInt(quantity.value, 10);

    const item = {
      id: currentVariantID,
      quantity: currentQuantity,
      compare_at_price: data.compare_at_price,
      tags: data.tags,
    };

    document.dispatchEvent(new CustomEvent('cart:add:variant', { detail: { items: [item] } }));
  });

  const quantityOpenTrigger:HTMLElement = node.querySelector('[data-quantity-trigger]');
  const quantitySelectionList:HTMLElement = node.querySelector('[data-quantity-selector]');
  const quantityButtons:NodeListOf<HTMLElement> = node.querySelectorAll('[data-amount]');
  const quantityStatus:HTMLSpanElement = node.querySelector('[data-quantity-status]');
  const quantityStatusText:HTMLSpanElement = quantityStatus.querySelector('[data-text]');
  quantityOpenTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    quantitySelectionList.hidden = !quantitySelectionList.hidden;
  });

  quantityButtons.forEach((button) => {
    button.addEventListener('click', () => {
      quantity.value = button.dataset.amount;
      quantityStatus.setAttribute('data-quantity-status', 'true');
      quantityStatusText.innerText = chosenQuantityTranslation.replace('{{ count }}', button.dataset.amount);
    });
  });

  document.addEventListener('click', (event) => {
    const target = event.target as HTMLElement;

    if (!quantityOpenTrigger.contains(target)) {
      quantitySelectionList.hidden = true;
    }
  });

  const initOptions = () => {
    const addToCart: HTMLButtonElement = node.querySelector('[data-add-to-cart]');
    const addToCartText = addToCart.querySelector('[data-text]');
    const price: HTMLElement = node.querySelector('[data-price]');
    const compareAtPrice: HTMLElement = node.querySelector('[data-compare-at-price]');

    const callback = (variant: Variant | null) => {
      if (variant) {
        const bis: HTMLElement = document.querySelector('button.klaviyo-bis-trigger');

        if (bis && addToCart) {
          addToCart.hidden = !variant.available;
          bis.hidden = variant.available;
        }

        price.textContent = `${formatMoney(variant.price)}`;

        if (variant.compare_at_price > variant.price) {
          compareAtPrice.hidden = false;
          compareAtPrice.innerHTML = `${formatMoney(variant.compare_at_price)}`;
        } else {
          compareAtPrice.hidden = true;
        }

        if (variant.available) {
          addToCartText.textContent = theme.strings.addToCart;
          addToCart.disabled = false;
        } else {
          addToCartText.textContent = theme.strings.soldOut;
          addToCart.disabled = true;
        }
      } else {
        addToCart.disabled = true;
      }
    };

    OptionSelector(`#product-${data.id}`, {
      data,
      onVariantSelected: callback,
      showSelectors: false,
    });
  };

  initOptions();

  const lightboxSelector = '[data-simplelightbox]';
  const lightBoxLinks = node.querySelectorAll(lightboxSelector);
  let MediaOverlay = null;

  for (const link of lightBoxLinks) { /* eslint-disable-line no-restricted-syntax */
    link.addEventListener('click', (e) => { /* eslint-disable-line @typescript-eslint/no-loop-func */
      e.preventDefault();

      if (MediaOverlay) {
        MediaOverlay.open(link);
      }
    });

    link.addEventListener('mouseover', async () => { /* eslint-disable-line @typescript-eslint/no-loop-func */
      const Lightbox = (await import(
        /* webpackChunkName: "SimpleLightbox" */
        'modules/simplelightbox'
      )).default;

      MediaOverlay = new Lightbox(lightboxSelector);
    });
  }
});
